import { useState } from 'react';

type PythonProps = {
  paddValue?: number;
};

export const Python2 = ({ paddValue }: PythonProps) => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div style={{ paddingLeft: `${paddValue}px` }}>
      <code>{'export async function getServerSideProps() {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {"const res = await fetch('http://localhost:5000/api/data');"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const data = await res.json();'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'return { props: { data } };'}
      </code>
      <br />
      <code>{'}'}</code>
      <br />
      <br />
      <code>{'export default function Home({ data }) {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'return ('}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'<div>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'<h1>Data from Backend</h1>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'<pre>{JSON.stringify(data, null, 2)}</pre>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'</div>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{')'}</code>
      <br />
      <code>{'}'}</code>
    </div>
  );
};
